import { StatusIndicator } from '@mss/mss-component-library';
import { useTranslation } from 'react-i18next';
import React from 'react';

const SessionStatus = ({ status }: any) => {
  const [t] = useTranslation(['remoteAccess', 'common']);
  if (typeof status !== 'string') return null;
  switch (status.toLowerCase()) {
    case 'active':
      return (
        <>
          <StatusIndicator variant="green" /> {t('Active')}
        </>
      );
    case 'revoked':
      return (
        <>
          <StatusIndicator variant="red" /> {t('Revoked')}
        </>
      );
    case 'expired':
      return (
        <>
          <StatusIndicator variant="red" /> {t('Expired')}
        </>
      );
    case 'expired_unapproved':
      return (
        <>
          <StatusIndicator variant="red" /> {t('Expired approval')}
        </>
      );
    case 'inactive':
      return (
        <>
          <StatusIndicator variant="grey" /> {t('Inactive')}
        </>
      );
    default:
      return null;
  }
};

export default SessionStatus;
